import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Smartphone } from "lucide-react";
import { openInstall, isStandalone } from "@/lib/install";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/api";
import { useVip } from "@/hooks/useVip";

const LINKS = [
  ["shows", "Shows"],
  ["founders", "Founders"],
  ["crew", "Crew"],
  ["hosts", "Hosts"],
  ["gallery", "Gallery"],
  ["vip", "VIP"],
  ["merch", "Booking"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const vip = useVip();
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header className={`fixed top-0 inset-x-0 z-50 pt-[env(safe-area-inset-top)] transition-colors duration-300 ${scrolled || open ? "bg-black/75 backdrop-blur-xl border-b border-white/10" : "bg-transparent"}`}>
      <nav className="flex items-center justify-between px-5 md:px-10 h-16 md:h-20">
        <button data-testid="nav-logo" className="shrink-0" onClick={() => go("top")} aria-label="Back to top"><Logo /></button>
        <div className="hidden xl:flex items-center gap-5 2xl:gap-7 font-mono text-xs uppercase tracking-[0.12em] 2xl:tracking-[0.2em] whitespace-nowrap [&_button]:uppercase">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-${id}-link`} onClick={() => go(id)} className="text-zinc-300 hover:text-[#56ED4A] transition-colors">{label}</button>
          ))}
          <Link to="/admin/login" data-testid="nav-admin-link" className="text-zinc-300 hover:text-[#56ED4A] transition-colors">Admin</Link>
          {!isStandalone() && (
            <button data-testid="nav-get-app-btn" onClick={openInstall} className="flex items-center gap-2 px-4 py-3 border border-[#56ED4A] text-[#56ED4A] hover:bg-[#56ED4A] hover:text-black transition-colors"><Smartphone size={14} /> Get the App</button>
          )}
          {vip ? (
            <span data-testid="nav-vip-badge" className="px-3 py-2 bg-[#56ED4A] text-black font-semibold">VIP · {vip}</span>
          ) : (
            <button data-testid="nav-get-pass-btn" onClick={() => go("vip")} className="px-5 py-3 bg-[#56ED4A] text-black font-semibold hover:bg-white transition-colors">Get the Pass</button>
          )}
        </div>
        <button data-testid="nav-mobile-toggle" className="xl:hidden p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X /> : <Menu />}
        </button>
      </nav>
      {open && (
        <div data-testid="nav-mobile-menu" className="xl:hidden px-5 pb-6 flex flex-col gap-1">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-mobile-${id}-link`} onClick={() => go(id)} className="text-left font-display text-4xl uppercase py-2 border-b border-white/10">{label}</button>
          ))}
          {!isStandalone() && (
            <button data-testid="nav-mobile-get-app-btn" onClick={() => { setOpen(false); openInstall(); }} className="mt-4 flex items-center justify-center gap-2 bg-[#56ED4A] text-black py-4 font-mono text-sm uppercase tracking-[0.2em] font-semibold"><Smartphone size={16} /> Get the App</button>
          )}
          <Link to="/admin/login" data-testid="nav-mobile-admin-link" className="mt-2 text-center border border-white/20 py-4 font-mono text-sm uppercase tracking-[0.2em] text-zinc-200">Admin login</Link>
        </div>
      )}
    </header>
  );
};
